import { icons } from './icons/index';
import { images } from './images/index';

export const assets = {
  images,
  icons,
};
